import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        isAuthorize: true,
        isInfor: '',
        ws: ''
    },
    mutations: {
        getAuthorize(state, isAuthorize) {
            state.isAuthorize = isAuthorize
        },
        getInfor(state, isInfor) {
            state.isInfor = isInfor
        },
        getWs(state, ws) {
            state.ws = ws
        }
    },
    actions: {

    }
})
